// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2oMgC","title":"Info_title__3bKl2","links":"Info_links__lUIcZ","link":"Info_link__23CVC","logo":"Info_logo__1tXHY"};